import React from "react";
import Button from "../../../../modules/commons/Button";
import moment from "moment";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";

export const tableConfig = ({ handleDetail }) => [
  {
    name: "id",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{rowNumber}</>;
      },
      sort: false,
    },
  },
  {
    name: "spbhDate",
    label: "Tanggal SPBH",
    options: {
      sort: false,
    },
  },
  {
    name: "spbhNo",
    label: "No. SPBH",
    options: {
      sort: false,
    },
  },
  {
    name: "spbmNo",
    label: "No. SPBM",
    options: {
      sort: false,
    },
  },
  {
    name: "spbmDate",
    label: "Tanggal SPBM",
    options: {
      sort: false,
    },
  },
  {
    name: "total",
    label: "Jumlah",
    options: {
      sort: false,
    },
  },
  {
    name: "notes",
    label: "Catatan",
    options: {
      sort: false,
    },
  },
  {
    name: "spbhNo",
    label: "Aksi",
    options: {
      customBodyRender: (val, tableMeta) => {
        return (
          <React.Fragment>
            <Button
              className="btnAct background-transparent txt-site txt-title"
              onClick={() => handleDetail(val)}
            >
              <i className="fa fa-eye color-red" />
            </Button>
          </React.Fragment>
        );
      },
      sort: false,
    },
  },
];

export const INITIAL_SEARCH = {
  spbhStartDate: moment().format("DD-MM-YYYY"),
  spbhEndDate: moment().format("DD-MM-YYYY"),
};
export const INITIAL_FILTER_DATA = {
  kodeCabang: null,
  spbhStartDate: null,
  spbhEndDate: null,
  spbmStartDate: null,
  spbmEndDate: null,
  spbhNo: null,
  spbmNo: null,
  giftCode: null,
  giftCategory: null,
  idLocator: null,
};
export const INITIAL_PAGINATION = {
  totalData: 0,
  limit: 5,
  page: 1,
};

export const formGroupGift = {
  id: { value: null },
  spbmNo: { value: null },
  spbmDate: { value: null },
  spbhNo: { value: null },
  spbhDate: { value: moment().format("DD-MM-YYYY"), mandatory: true },
  slNo: { value: null },
  slDate: { value: null },
  noPolKendaraan: { value: null },
  idSupplier: { value: null, mandatory: true },
  idSupplierExpedisi: { value: null },
  note: { value: null },
  kodeCabang: { value: null },
  noQrGift: { value: [] },
  qrGift: { value: [] },
};

export const tableConfigQr = [
  {
    name: "kodeHadiah",
    label: "Kode Hadiah",
  },
  {
    name: "namaHadiah",
    label: "Nama Hadiah",
  },
  {
    name: "kategori",
    label: "Kategori",
  },
  {
    name: "qrcode",
    label: "QRCode",
  },
  {
    name: "locator",
    label: "Locator",
  },
  {
    name: "numbersOfPrint",
    label: "Jml. Print",
  },
];

export const tableConfigNoQr = [
  {
    name: "kodeHadiah",
    label: "Kode Hadiah",
  },
  {
    name: "namaHadiah",
    label: "Nama Hadiah",
  },
  {
    name: "kategori",
    label: "Kategori",
  },
  {
    name: "jumlah",
    label: "Jumlah",
  },
  {
    name: "satuan",
    label: "Satuan",
  },
  {
    name: "locator",
    label: "Locator",
  },
];

export const tableConfigCreate = ({
  dataHadiah,
  onKodeHadiahChange,
  onChangeAllLocator,
  dataLocator,
  onTableValueChange,
  onDeleteRow,
  onSaveRow,
  dataTable,
  openKodeHadiah,
}) => [
  {
    name: "id",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        return <>{tableMeta.rowIndex + 1}</>;
      },
      sort: false,
    },
  },
  {
    name: "kodeHadiah",
    label: "Kode Hadiah",
    options: {
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return <p>{val?.value}</p>;
        }
        return (
          <React.Fragment>
            <SimpleDDL
              id="options_kode_hadiah"
              options={dataHadiah}
              name="kodeHadiah"
              box="search"
              styles={{
                menu: (provided) => ({
                  ...provided,
                  position: "relative",
                  fontFamily:
                    "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                }),
              }}
              containerclassname="margin-bottom-none"
              value={val}
              onMenuOpen={openKodeHadiah}
              onChange={(value) =>
                onKodeHadiahChange(rowIndex, "kodeHadiah", value)
              }
            />
          </React.Fragment>
        );
      },
      sort: false,
    },
  },
  {
    name: "namaHadiah",
    label: "Nama Hadiah",
    options: {
      customBodyRender: (val, tableMeta) => {
        return <p>{val}</p>;
      },
      sort: false,
    },
  },
  {
    name: "kategori",
    label: "Kategori",
    options: {
      customBodyRender: (val, tableMeta) => {
        return <p>{val}</p>;
      },
      sort: false,
    },
  },
  {
    name: "jumlah",
    label: (
      <>
        Jumlah <span style={{ color: "red" }}>*</span>
      </>
    ),
    options: {
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return <p>{val}</p>;
        }
        return (
          <SimpleInput
            id="input_jumlah"
            box="number"
            name="jumlah"
            value={val}
            containerclassname="width width-80px"
            onValueChange={({ value }) =>
              onTableValueChange(rowIndex, "jumlah", value)
            }
          />
        );
      },
      sort: false,
    },
  },
  {
    name: "satuan",
    label: "Satuan",
    options: {
      customBodyRender: (val, tableMeta) => {
        return <p>{val}</p>;
      },
      sort: false,
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "locator",
    label: (
      <>
        [<span style={{ color: "red" }}>*</span>] All Locator
      </>
    ),
    options: {
      customHeadRender: (props) => {
        return (
          <th className="custom-locator">
            <FlexView
              vAlignContent="center"
              style={{ gap: "10px", zIndex: 100 }}
            >
              <p>{props.label}</p>
              <SimpleDDL
                id="select_options_header_locator"
                containerclassname="margin-bottom-none width width-200px"
                box="search"
                isClearable
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    position: "relative",
                    fontFamily:
                      "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                  }),
                }}
                options={dataLocator}
                onChange={onChangeAllLocator}
              />
            </FlexView>
          </th>
        );
      },
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        return isSaved ? (
          <p>{val?.label}</p>
        ) : (
          <SimpleDDL
            id={`select_options_locator_${rowIndex}`}
            containerclassname="margin-bottom-none width width-200px"
            box="search"
            value={val}
            menuPosition="fixed"
            options={dataLocator}
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            readOnly={isSaved}
            isClearable={true}
            onChange={(value) => onTableValueChange(rowIndex, "locator", value)}
          />
        );
      },
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
    },
  },
  {
    name: "saved",
    label: "Aksi",
    options: {
      customBodyRender: (val, { rowIndex }) => {
        return (
          <React.Fragment>
            <FlexView style={{ gap: "15px" }}>
              {!val ? (
                <React.Fragment>
                  <SimpleButton
                    className={"btn background-red"}
                    styles={{ width: "unset", marginLeft: "0px" }}
                    onClick={() => onSaveRow(rowIndex, "saved", true)}
                    icon={<i className="fa fa-save" />}
                  />
                  <SimpleButton
                    className={"btn background-red"}
                    styles={{ width: "unset", marginLeft: "0px" }}
                    onClick={() => onDeleteRow(rowIndex)}
                    icon={<i className="fa fa-trash"></i>}
                  />
                </React.Fragment>
              ) : dataTable && dataTable?.[rowIndex].checkEdit !== false ? (
                <React.Fragment>
                  <SimpleButton
                    className={"btn background-red"}
                    styles={{ width: "unset", marginLeft: "0px" }}
                    onClick={() => onTableValueChange(rowIndex, "saved", false)}
                    icon={<i className="fa fa-lw fa-pencil-alt" />}
                  />
                  <SimpleButton
                    className={"btn background-red"}
                    styles={{ width: "unset", marginLeft: "0px" }}
                    onClick={() => onDeleteRow(rowIndex)}
                    icon={<i className="fa fa-trash"></i>}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment></React.Fragment>
              )}
            </FlexView>
          </React.Fragment>
        );
      },
      sort: false,
    },
  },
];

export const INITIAL_DATA_CREATE = {
  kodeHadiah: null,
  namaHadiah: null,
  categoryHadiah: null,
  jumlah: null,
  satuan: null,
  locator: null,
  saved: false,
  checkEdit: true,
};
